/* Copyright (c) 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import dayjs from "dayjs";
import { Text, theme } from "@nordcloud/gnui";
import { dateFormat } from "~/tools";
import { FooterWrapper } from "./styles";

export function Footer() {
  return (
    <FooterWrapper>
      <div className="footer">
        <Text size="sm" color={theme.color.text.text02} align="center">
          IBM&nbsp;Multicloud&nbsp;Panel by Nordcloud Oy © {dayjs().format(dateFormat.year)}
        </Text>
      </div>
    </FooterWrapper>
  );
}
